import { Spx } from '@wix/thunderbolt-becky-types'

export const CONTAINER_TYPES = {
	Page: true,
	MasterPage: true,
	AppPage: true,
	VerticalRepeater: true,
	QuickActionBar: true,
	PageGroup: true,
	SiteRegionContainer: true,
	Container: true,
	MediaBox: true,
	HoverBox: true,
	PopupContainer: true,
	Group: true,
	FormContainer: true,
	WSiteStructure: true,
	HeaderContainer: true,
	FooterContainer: true,
	PagesContainer: true,
	StripContainer: true,
	StripColumnsContainer: true,
	ClassicSection: true,
	Column: true,
	MediaPlayer: true,
	ScreenWidthContainer: true,
	Area: true,
	BoxSlideShow: true,
	StateBox: true,
	StateStrip: true,
	StateBoxState: true,
	StateBoxFormState: true,
	StateStripState: true,
	StripContainerSlideShow: true,
	BoxSlideShowSlide: true,
	StripContainerSlideShowSlide: true,
	Repeater: true,
	MediaContainer: true,
	MenuContainer: true,
	AppWidget: true,
	Popover: true,
	RefComponent: true,
	Section: true,
	HeaderSection: true,
	FooterSection: true,
	MembersAreaSection: true,
	MultiStateBox: true,
	MegaMenuContainerItem: true,
	StretchedContainer: true,
	SettingsPanelContainer: true,
	SingleTab: true,
	AccordionItem: true,
	SelectableContainer: true,
}

export const SPX_VALUE_REGEX = /[0-9]*\.?[0-9]*spx/
export const UNITLESS_NUMBERS_REGEX = /\b[0-9]*\.?[0-9]+(?=\s|[^a-zA-Z0-9.]|$)/

export const resolveSpxAttribute = (value: string | number, spx: Spx | undefined, keepNumValues: boolean) => {
	const valuesWithResolvedSpx = `${value}`.replace(new RegExp(SPX_VALUE_REGEX, 'g'), (spxValue) =>
		resolveSpxValue(spxValue, spx)
	)

	return keepNumValues
		? valuesWithResolvedSpx
		: `${valuesWithResolvedSpx}`.replace(
				new RegExp(UNITLESS_NUMBERS_REGEX, 'g'),
				(numberedValue) => `${numberedValue}px`
		  )
}

export const resolveSpxValue = (spxValue: string, spx: Spx | undefined) => {
	const { refWidth, resolverType } = spx ?? {}
	const isScale = resolverType === 'scale'

	const numericValue = parseFloat(spxValue)
	return isNaN(numericValue)
		? spxValue
		: isScale && refWidth && numericValue !== 0
		? `calc(${(numericValue / refWidth) * 100} * var(--one-unit))`
		: `${numericValue}px`
}
